module.exports = __webpack_public_path__ + "static/media/choithramsEatHealthy.26738d39.png";